import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import QRCode from 'qrcode.react';
import stylesPay from './ButtonPayAntiInfo.module.less';

import config from './config';
import { logging } from '../../actions/log';
import { setOrderInfo, setAntiInfo, setPayPaySuc, setPayCheckIdSuc } from '../../actions/buttonpay';
import Toast from '../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectButtonPay = createSelector(
  state => state.buttonpay,
  buttonpay => buttonpay,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { btnPayOrder, btnPayAnti, btnPayPaySuc, btnPayAntiSuc } = useSelector(selectButtonPay);

  // isLoading 0: 还未认证   1: 认证请求中   2: 认证失败
  const [isLoading, setIsLoading] = useState(0);
  const [nameValue, setNameValue] = useState('');
  const [nameErr, setNameErr] = useState(false);
  const [nameDom, setNameDom] = useState(null);
  const [cardIdValue, setCardIdValue] = useState('');
  const [cardIdErr, setCardIdErr] = useState(false);
  const [cardIdDom, setCardIdDom] = useState(null);

  useEffect(() => {
    loggingOrder('P', 'PayGame_Certification');
  }, []);

  const loggingOrder = useCallback(
    (category, action) => {
      dispatch(
        logging({
          category: category || 'C',
          action: action || 'PayGame_Certification',
          label: '',
          param2: {
            source: btnPayAnti?.logInfo?.source,
            source_p: logInfoData?.source_p,
            source_pp: logInfoData?.source_pp,
            softid: btnPayAnti?.soft?.softID,
            softName: btnPayAnti?.soft?.softName,
            softType: '0',
          },
          param3: btnPayAnti?.soft?.bizInfo || null,
        }),
      );
    },
    [btnPayAnti, logInfoData],
  );

  const checkValue = useCallback(() => {
    if (!nameValue || nameValue.length < 2 || nameValue.length > 15) {
      setNameErr(true);
      return false;
    }
    if (!cardIdValue || !config.checkUserCardId(cardIdValue)) {
      setCardIdErr(true);
      return false;
    }
    return true;
  }, [nameValue, cardIdValue]);

  const handleSure = useCallback(
    async e => {
      if (!checkValue()) {
        return;
      }
      loggingOrder('C', 'PayGame_Certification_Submit');

      setIsLoading(1);
      let res = await config.userCertification({ idCardNumber: cardIdValue, name: nameValue });

      if (res.status === 0) {
        loggingOrder('R', 'PayGame_Certification_Success');
        Toast.success({
          content: '身份认证成功！',
        });
        dispatch(
          setPayCheckIdSuc({
            soft: btnPayAnti?.soft,
            result: res?.data,
          }),
        );
        setNameErr(false);
        setCardIdErr(false);
        setIsLoading(0);
        dispatch(setAntiInfo({}));
      } else {
        loggingOrder('R', 'PayGame_Certification_Fail');
        setIsLoading(2);
      }
    },
    [nameValue, cardIdValue, btnPayAnti],
  );
  const handleChangeName = useCallback(e => {
    const inputValue = e.target.value;
    setNameValue(inputValue);
    setNameErr(false);
  }, []);
  const handleChangeCardId = useCallback(e => {
    const inputValue = e.target.value;
    setCardIdValue(inputValue);
    setCardIdErr(false);
  }, []);
  const handleDialogClose = useCallback(e => {
    loggingOrder('C', 'PayGame_Certification_Close');
    setNameErr(false);
    setCardIdErr(false);
    setIsLoading(0);
    dispatch(setAntiInfo({}));
  }, []);
  const handleTocustomer = useCallback(
    e => {
      loggingOrder('C', 'PayGame_Certification_Tocustomer');
      window.open(`https://wpa1.qq.com/z914HEIy?_type=wpa&qidian=true}`);
    },
    [btnPayAnti, logInfoData],
  );

  return (
    <div className={stylesPay.dialog_box}>
      <div className={stylesPay.dialog_order}>
        <div className="order_header">
          <div className="order_header_text">温馨提示</div>
          <div
            className="order_header_close iconfont icon-opt_close"
            onClick={handleDialogClose}
          ></div>
        </div>
        {(isLoading === 0 || isLoading === 2) && (
          <>
            <div className="order_cont">
              {isLoading === 0 && (
                <div className={'order_text'}>
                  亲爱的用户，根据《关于防止未成年人沉迷网络游戏的通知》等相关规定，您需要实名登记后进行。
                </div>
              )}
              {isLoading === 2 && (
                <div className={'order_text_err'}>
                  <div className={'order_text_err_1'}>实名认证失败</div>
                  <div className={'order_text_err_2'}>
                    您可以尝试再次提交，也可以<span onClick={handleTocustomer}>联系客服</span>
                  </div>
                </div>
              )}
              <div className={'order_item'}>
                <div className={'order_input_text'}>
                  <span className={'order_input_text_star'}>*</span> 姓名
                </div>
                <div className={'order_input_box'}>
                  <input
                    type="text"
                    className={nameErr ? 'order_input input_err' : 'order_input'}
                    placeholder="请输入姓名"
                    ref={dom => {
                      setNameDom(dom);
                    }}
                    onChange={handleChangeName}
                    value={nameValue}
                  />
                  {nameErr && (
                    <div className={'order_err_info'}>
                      <span className={'order_err_info_icon iconfont icon-tips'}></span>
                      请输入2-15个字的姓名
                    </div>
                  )}
                </div>
              </div>
              <div className={'order_item'}>
                <div className={'order_input_text'}>
                  <span className={'order_input_text_star'}>*</span> 身份证号
                </div>
                <div className={'order_input_box'}>
                  <input
                    type="text"
                    className={cardIdErr ? 'order_input input_err' : 'order_input'}
                    placeholder="请输入身份证号码"
                    ref={dom => {
                      setCardIdDom(dom);
                    }}
                    onChange={handleChangeCardId}
                    value={cardIdValue}
                  />
                </div>
                {cardIdErr && (
                  <div className={'order_err_info'}>
                    <span className={'order_err_info_icon iconfont icon-tips'}></span>
                    请输入正确的身份证号码
                  </div>
                )}
              </div>
            </div>
            <div className={'btn_sure'} onClick={handleSure}>
              提交
            </div>
          </>
        )}
        {isLoading === 1 && (
          <div className={'order_loading'}>
            <div className={'order_loading_img'}></div>
            <div className={'order_loading_info'}>正在进行实名认证，请稍后...</div>
            <div className={'order_loading_split'}></div>
            <div className={'btn_sure_disable'} onClick={handleSure}>
              提交
            </div>
          </div>
        )}
      </div>
    </div>
  );
});
